/**
 * Currency context (AOA / USD toggle).
 */
import { createContext, useContext, useState, useEffect } from "react";

const CurrencyCtx = createContext(null);

export function CurrencyProvider({ children }) {
    const [currency, setCurrency] = useState(() => localStorage.getItem("mesafa_currency") || "AOA");

    useEffect(() => {
        localStorage.setItem("mesafa_currency", currency);
    }, [currency]);

    const toggle = () => setCurrency((c) => (c === "AOA" ? "USD" : "AOA"));

    const format = (plan) => {
        if (!plan) return "";
        if (currency === "USD") {
            return `${Number(plan.price_usd).toLocaleString("en-US")} USD`;
        }
        return `${Number(plan.price_aoa).toLocaleString("pt-PT")} AOA`;
    };

    const formatAmount = (aoa, usd) => {
        if (currency === "USD") return `${Number(usd).toLocaleString("en-US")} USD`;
        return `${Number(aoa).toLocaleString("pt-PT")} AOA`;
    };

    return (
        <CurrencyCtx.Provider value={{ currency, setCurrency, toggle, format, formatAmount }}>
            {children}
        </CurrencyCtx.Provider>
    );
}

export const useCurrency = () => useContext(CurrencyCtx);
